import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth, afterLogin } from "@/context/AuthContext";
import StarField from "@/components/StarField";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { applyAuth } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login");
      return;
    }
    const sessionId = match[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId, ref: localStorage.getItem("mulankan_ref") || undefined });
        localStorage.removeItem("mulankan_ref");
        applyAuth(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(afterLogin());
      } catch {
        navigate("/login");
      }
    })();
  }, [navigate, applyAuth]);

  return (
    <div className="cosmic-bg min-h-screen flex items-center justify-center">
      <StarField />
      <div className="text-[var(--accent)] font-display text-2xl animate-pulse" data-testid="auth-callback-loading">Signing you in…</div>
    </div>
  );
}
